import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { Header } from '../Header'
import { Grid } from '../Grid'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    typ: 'grid',
  }
  const typ = properties?.typ

  return (
    <AppContainer className={globalClasses.join(' ')}>
      {typ === 'header' && (
        <Header
          title={'30<br /><span>unter</span><br />30'}
          lead={
            'Sie gehören zu den Nachwuchshoffnungen ihres Fachs: 30 junge Bernerinnen und Berner, die forschen, Musik komponieren, Sport betreiben oder gesellschaftliche Probleme angehen.'
          }
          tenant={tenant}
          colorMode={colorMode}
        />
      )}
      {typ !== 'header' && <Grid />}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
